import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { CallConfirmForm } from "./CallConfirmForm";

export const CallConfirmSheet = ({ selection, session, onClose, onStarted, onReturned }) => <Sheet
  open={Boolean(selection)} onOpenChange={(next) => { if (!next) onClose(); }}>
  <SheetContent side="bottom" className="hud-sheet" closeTestId="call-confirm-close-button" data-testid="call-confirm-sheet">
    <div className="sheet-grab" aria-hidden="true" />
    <SheetHeader><SheetTitle className="sr-only">Conferma chiamata</SheetTitle></SheetHeader>
    {selection && <CallConfirmForm key={`${selection.venue.id}-${selection.action.value}`}
      venue={selection.venue} action={selection.action} csrfToken={session.csrf_token}
      onBack={onClose} onStarted={onStarted} onReturned={onReturned} />}
  </SheetContent>
</Sheet>;